/* eslint-disable complexity */
import type { Renderable } from '@adornis/chemistry/renderable.js';
import { MailTemplateType, MailTemplateVars } from '../entities/mail-templates.js';

export function globalMailVariables(emailType: MailTemplateType): MailTemplateVars[] {
  switch (emailType) {
    case MailTemplateType.ABMELDUNG:
    case MailTemplateType.ABMELDUNG_DURCH_EINRICHTUNG:
    case MailTemplateType.BESTAETIGUNG_WORKSHOP_REGISTRIERUNG:
    case MailTemplateType.NACHRUECKPLATZ_VERFUEGBAR:
    case MailTemplateType.NACHRUECKPLATZ_ERHALTEN:
    case MailTemplateType.NUTZER_TEILNAHME_AUFGEHOBEN:
    case MailTemplateType.VERANSTALTUNGSEINTRAGUNG_DURCH_ADMIN:
    case MailTemplateType.WARTELISTE_VORRUECK:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.CHANGED_REGISTRATIONS,
        MailTemplateVars.CHANGED_REGISTRATIONS_EN,
        MailTemplateVars.OTHER_REGISTRATIONS,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.EVENT_TITLE,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.EVENT_DATES,
        MailTemplateVars.EVENT_LEAD_DAYS,
        MailTemplateVars.NEWSLETTER_OPTIN_LINK,
        MailTemplateVars.NEWSLETTER_OPTIN_LINK_EN,
      ];
    case MailTemplateType.NUTZER_TEILNAHME:
    case MailTemplateType.NUTZER_TEILNAHME_OHNE_ZERTIFIKAT:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.EVENT_TITLE,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.EVALUATION_LINK,
        MailTemplateVars.EVALUATION_CODE,
        MailTemplateVars.NEWSLETTER_OPTIN_LINK,
        MailTemplateVars.NEWSLETTER_OPTIN_LINK_EN,
      ];
    case MailTemplateType.PRODUCT_CANCELED:
    case MailTemplateType.PRODUCT_DECANCELED:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.WORKSHOP_NAME,
        MailTemplateVars.WORKSHOP_TERMINE,
        MailTemplateVars.WORKSHOP_LOCATION,
      ];
    case MailTemplateType.NEWSLETTER_OPTIN:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.NEWSLETTER_OPTIN_LINK,
        MailTemplateVars.NEWSLETTER_OPTIN_LINK_EN,
      ];

    case MailTemplateType.SPERRUNG:
    case MailTemplateType.SPERRUNG_AUFGEHOBEN:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.CHANGED_REGISTRATIONS,
        MailTemplateVars.CHANGED_REGISTRATIONS_EN,
      ];
    case MailTemplateType.ERINNERUNG:
    case MailTemplateType.ERINNERUNG_2:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.PRODUCT_CARD,
        MailTemplateVars.PRODUCT_CARD_EN,
        MailTemplateVars.AUTOMATIC_MOVE_UP_DAYS,
        MailTemplateVars.BLOCK_SIGNOFF_DAYS,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.DEREGISTER_LINK,
        MailTemplateVars.DEREGISTER_LINK_EN,
        MailTemplateVars.EVENT_LOCATION,
        MailTemplateVars.EVENT_DATES,
        MailTemplateVars.EVENT_LEAD_DAYS,
        MailTemplateVars.CHANGED_REGISTRATIONS,
        MailTemplateVars.CHANGED_REGISTRATIONS_EN,
        MailTemplateVars.EVALUATION_LINK,
        MailTemplateVars.EVALUATION_CODE,
        MailTemplateVars.MEETING_LINK,
        MailTemplateVars.MEETING_CODE,
        MailTemplateVars.MEETING_PASSWORD,
        MailTemplateVars.NEWSLETTER_OPTIN_LINK,
        MailTemplateVars.NEWSLETTER_OPTIN_LINK_EN,
      ];
    case MailTemplateType.ERINNERUNG_APPOINTMENT:
    case MailTemplateType.ERINNERUNG_APPOINTMENT_2:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.PRODUCT_CARD,
        MailTemplateVars.PRODUCT_CARD_EN,
        MailTemplateVars.APPOINTMENT_NAME,
        MailTemplateVars.APPOINTMENT_START,
        MailTemplateVars.APPOINTMENT_END,
        MailTemplateVars.APPOINTMENT_LOCATION,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.DEREGISTER_LINK,
        MailTemplateVars.DEREGISTER_LINK_EN,
        MailTemplateVars.EVENT_DATES,
        MailTemplateVars.CHANGED_REGISTRATIONS,
        MailTemplateVars.CHANGED_REGISTRATIONS_EN,
        MailTemplateVars.EVALUATION_LINK,
        MailTemplateVars.EVALUATION_CODE,
        MailTemplateVars.MEETING_LINK,
        MailTemplateVars.MEETING_CODE,
        MailTemplateVars.MEETING_PASSWORD,
        MailTemplateVars.NEWSLETTER_OPTIN_LINK,
        MailTemplateVars.NEWSLETTER_OPTIN_LINK_EN,
      ];
    case MailTemplateType.MEETING_INFOS:
    case MailTemplateType.MEETING_INFOS_2:
    case MailTemplateType.EINZELBERATUNG_MEETING_INFOS:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.MEETING_LINK,
        MailTemplateVars.MEETING_CODE,
        MailTemplateVars.MEETING_PASSWORD,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.PRODUCT_CARD,
        MailTemplateVars.PRODUCT_CARD_EN,
        MailTemplateVars.EVALUATION_LINK,
        MailTemplateVars.EVALUATION_CODE,
        MailTemplateVars.EVENT_DATES,
      ];
    case MailTemplateType.MEETING_INFOS_IN_PERSON:
    case MailTemplateType.MEETING_INFOS_2_IN_PERSON:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.APPOINTMENT_LOCATION,
        MailTemplateVars.EVENT_LOCATION,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.PRODUCT_CARD,
        MailTemplateVars.PRODUCT_CARD_EN,
        MailTemplateVars.EVALUATION_LINK,
        MailTemplateVars.EVALUATION_CODE,
        MailTemplateVars.EVENT_DATES,
      ];
    case MailTemplateType.MEETING_INFOS_HYBRID:
    case MailTemplateType.MEETING_INFOS_2_HYBRID:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.MEETING_LINK,
        MailTemplateVars.MEETING_CODE,
        MailTemplateVars.MEETING_PASSWORD,
        MailTemplateVars.APPOINTMENT_LOCATION,
        MailTemplateVars.EVENT_LOCATION,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.PRODUCT_CARD,
        MailTemplateVars.PRODUCT_CARD_EN,
        MailTemplateVars.EVALUATION_LINK,
        MailTemplateVars.EVALUATION_CODE,
        MailTemplateVars.EVENT_DATES,
      ];
    case MailTemplateType.OTP:
      return [
        MailTemplateVars.TITLE, //
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.OTP,
      ];
    case MailTemplateType.CHANGE_EMAIL:
      return [
        MailTemplateVars.TITLE, //
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.CHANGE_EMAIL_LINK,
      ];
    case MailTemplateType.FORGOT_PASSWORD:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.FORGOT_PASSWORD_LINK,
      ];
    case MailTemplateType.PRODUKT_LOESCHUNG:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.INSTITUTION_NAME,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.PRODUCT_CARD,
        MailTemplateVars.PRODUCT_CARD_EN,
      ];
    case MailTemplateType.PRODUCT_CHANGED:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.CHANGED_REGISTRATIONS,
        MailTemplateVars.CHANGED_REGISTRATIONS_EN,
        MailTemplateVars.PRODUCT_CHANGES,
        MailTemplateVars.PRODUCT_CHANGES_EN,
        MailTemplateVars.LOGIN_LINK,
      ];
    case MailTemplateType.IKH_INVOICE_USER:
    case MailTemplateType.SD_INVOICE_USER:
    case MailTemplateType.DEMO_INVOICE_USER:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.WORKSHOP_NAME,
        MailTemplateVars.WORKSHOP_TERMINE,
        MailTemplateVars.WORKSHOP_LOCATION,
        MailTemplateVars.LOGIN_LINK,
      ];
    case MailTemplateType.IKH_INVOICE_INSTITUTION:
    case MailTemplateType.SD_INVOICE_INSTITUTION:
    case MailTemplateType.DEMO_INVOICE_INSTITUTION:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.WORKSHOP_NAME,
        MailTemplateVars.WORKSHOP_TERMINE,
        MailTemplateVars.WORKSHOP_LOCATION,
        MailTemplateVars.LOGIN_LINK,
      ];
    case MailTemplateType.LECTURER_REGISTRATION:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.INSTITUTION_NAME,
      ];
    case MailTemplateType.LECTURER_ADDED_TO_PRODUCT:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.INSTITUTION_NAME,
      ];
    case MailTemplateType.INFO_NEWSLETTER:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.BOOKABLE_WORKSHOPS,
        MailTemplateVars.BOOKABLE_WORKSHOPS_EN,
        MailTemplateVars.UNSUBSCRIBE_FROM_NEWSLETTER_LINK,
      ];
    case MailTemplateType.FREE_FORM:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.INSTITUTION_NAME,
      ];
    case MailTemplateType.NEW_WORKSHOP_DOCUMENTS:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.DOCUMENT_LINKS,
      ];
    case MailTemplateType.NUTZER_WORKSHOP_SET_TEILNAHME:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.LOGIN_LINK,
        MailTemplateVars.PRODUCT_NAME,
      ];
    case MailTemplateType.LECTURER_WORKSHOP_REMINDER:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.PRODUCT_CARD,
        MailTemplateVars.EVENT_LOCATION,
        MailTemplateVars.EVENT_DATES,
        MailTemplateVars.EVENT_LEAD_DAYS,
        MailTemplateVars.EVALUATION_LINK,
        MailTemplateVars.EVALUATION_CODE,
      ];
    case MailTemplateType.LECTURER_EVALUATION_MAIL:
      return [
        MailTemplateVars.TITLE,
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.PRODUCT_CARD,
        MailTemplateVars.EVENT_LOCATION,
        MailTemplateVars.EVENT_DATES,
        MailTemplateVars.EVENT_LEAD_DAYS,
        MailTemplateVars.EVALUATION_LINK,
        MailTemplateVars.EVALUATION_CODE,
      ];
    case MailTemplateType.NICHT_ERSCHIENEN:
      return [
        MailTemplateVars.FIRST_NAME,
        MailTemplateVars.LAST_NAME,
        MailTemplateVars.PRODUCT_NAME,
        MailTemplateVars.EVENT_DATES,
      ];
    default:
      return [];
  }
}

export function globalMailHint(emailType: MailTemplateType): Renderable {
  switch (emailType) {
    case MailTemplateType.OTP:
      return 'Mail wird verschickt, wenn sich ein Nutzer bei der Registrierung mit einem 6-stelligen Code authentifizieren muss.';
    case MailTemplateType.CHANGE_EMAIL:
      return 'Mail wird verschickt, wenn ein Nuzter angefordert hat seine E-Mail-Adresse zu ändern.';
    case MailTemplateType.NUTZER_TEILNAHME_AUFGEHOBEN:
      return 'Mail wird manuell durch den Admin verschickt nachdem ein Teilnehmer an einem Workshop nichtmehr teilgenommen hat.';
    case MailTemplateType.WARTELISTE_VORRUECK:
      return 'Mail wird verschickt, wenn sich der Wartelistenplatz ändert.';
    case MailTemplateType.NUTZER_TEILNAHME:
    case MailTemplateType.NUTZER_TEILNAHME_OHNE_ZERTIFIKAT:
      return 'Mail wird verschickt nachdem ein Teilnehmer an einem Workshop teilgenommen hat.';
    case MailTemplateType.BESTAETIGUNG_WORKSHOP_REGISTRIERUNG:
      return 'Bestätigungsmail nach erfolgreichem Registrieren zu Workshops.';
    case MailTemplateType.PRODUCT_CANCELED:
      return 'Mail wird verschickt, wenn ein Event abgesagt wurde.';
    case MailTemplateType.PRODUCT_DECANCELED:
      return 'Mail wird verschickt, wenn ein ein ehamls abgesages Event wieder aktiviert wurde.';
    case MailTemplateType.SPERRUNG:
      return 'Mail wird verschickt, wenn ein Nutzer gesperrt wurde.';
    case MailTemplateType.SPERRUNG_AUFGEHOBEN:
      return 'Mail wird verschickt, wenn ein Nutzer entsperrt wurde.';
    case MailTemplateType.NACHRUECKPLATZ_VERFUEGBAR:
      return 'Mail wird verschickt, wenn ein für einen wartenden Nuter die Möglichkeit besteht dem Workshop beizutreten';
    case MailTemplateType.NACHRUECKPLATZ_ERHALTEN:
      return 'Mail wird verschickt, wenn ein Teilnehmer durch die Abmeldung anderer Teilnehmer einen Platz in eime Workshop erhalten hat.';
    case MailTemplateType.VERANSTALTUNGSEINTRAGUNG_DURCH_ADMIN:
      return 'Mail wird verschickt, wenn ein Admin einen Teilnehmern manuell zu einem Workshop zulässt.';
    case MailTemplateType.ABMELDUNG:
      return 'Bestätigungsmail, nachdem der Nutzer sich selbst von einem Workshop abgemeldet hat.';
    case MailTemplateType.ABMELDUNG_DURCH_EINRICHTUNG:
      return 'Mail wird verschickt, wenn ein Admin einen Teilnehmer von einer Veranstaltung abmeldet.';
    case MailTemplateType.ERINNERUNG:
    case MailTemplateType.ERINNERUNG_2:
      return 'Wird einige Zeit vor Start des Workshops an alle Teilnehmer verschickt.';
    case MailTemplateType.MEETING_INFOS:
    case MailTemplateType.MEETING_INFOS_2:
    case MailTemplateType.MEETING_INFOS_IN_PERSON:
    case MailTemplateType.MEETING_INFOS_2_IN_PERSON:
    case MailTemplateType.MEETING_INFOS_HYBRID:
    case MailTemplateType.MEETING_INFOS_2_HYBRID:
      return (
        'Wird für jeden Workshop-Termin an alle Teilnehmer verschickt: der 1. Versand vor Beginn, der 2. Versand als Erinnerung am Veranstaltungstag, jeweils gemäß dem eingestellten Versandvorlauf. Die Variante Online, vor Ort oder Hybrid wird anhand des Veranstaltungsformats des Produkts gewählt. "nicht ausgewählt" und fehlende Angaben werden als Online behandelt. {{appointment-location}} verwendet den Kursort des Produkts (gegebenenfalls geerbt), wenn am Termin kein Ort angegeben ist.' +
        (emailType === MailTemplateType.MEETING_INFOS_IN_PERSON ||
        emailType === MailTemplateType.MEETING_INFOS_2_IN_PERSON
          ? ''
          : ' {{meeting-code}} und {{meeting-password}} geben den Meeting-Code und das Meeting-Passwort separat aus.')
      );
    case MailTemplateType.EINZELBERATUNG_MEETING_INFOS:
      return 'Wird einige Zeit vor Start der Einzelberatung an alle Teilnehmer verschickt. {{meeting-code}} und {{meeting-password}} geben den Meeting-Code und das Meeting-Passwort separat aus.';
    case MailTemplateType.ERINNERUNG_APPOINTMENT:
    case MailTemplateType.ERINNERUNG_APPOINTMENT_2:
      return 'Wird für jeden Termin einige Zeit vor Beginn an alle Teilnehmer verschickt.';
    case MailTemplateType.FORGOT_PASSWORD:
      return `Wird verschickt, wenn ein Nuitzer sein Passwort vergessen hat und ein neues setzen möchte.`;
    case MailTemplateType.PRODUKT_LOESCHUNG:
      return 'Wenn ein Produkt gelöscht wird, wird diese Mail an alle Teilnehmer verschickt.';
    case MailTemplateType.PRODUCT_CHANGED:
      return 'Wenn ein Produkt geändert wird, wird diese Mail an alle Teilnehmer verschickt.';
    case MailTemplateType.IKH_INVOICE_USER:
    case MailTemplateType.SD_INVOICE_USER:
    case MailTemplateType.DEMO_INVOICE_USER:
      return 'Mit dieser Mail werden Nutzern Rechnungen übermittelt.';
    case MailTemplateType.IKH_INVOICE_INSTITUTION:
    case MailTemplateType.SD_INVOICE_INSTITUTION:
    case MailTemplateType.DEMO_INVOICE_INSTITUTION:
      return 'Diese Mail wird der Rechnungstelle gesendet wenn einem Nutzer eine Rechnung ausgestellt wurde.';
    case MailTemplateType.INFO_NEWSLETTER:
      return 'Diese Mail wird alle 14 Tage an alle Teilnehmer gesendet, um über neue Angebote zu informieren';
    case MailTemplateType.NEWSLETTER_OPTIN:
      return 'Diese Mail wird an alle Teilnehmer versendet, wenn sie sich für den Newsletter anmelden.';
    case MailTemplateType.LECTURER_REGISTRATION:
      return 'Diese Mail wird an Dozierende versendet, wenn ihr Nutzeraccount angelegt wird.';
    case MailTemplateType.LECTURER_ADDED_TO_PRODUCT:
      return 'Diese Mail wird an Dozierende versendet wenn sie zu einem Produkt hinzugefügt wurden.';
    case MailTemplateType.NEW_WORKSHOP_DOCUMENTS:
      return 'Diese Mail wird an Nutzer versendet wenn einem Workshop ein neues Dokument hinzugefügt wurde.';
    case MailTemplateType.NUTZER_WORKSHOP_SET_TEILNAHME:
      return 'Diese Mail wird an Nutzer versendet die allen Workshops einer Workshop-Reihe erfolgreich teilgenommen haben.';
    case MailTemplateType.LECTURER_WORKSHOP_REMINDER:
      return 'Diese Mail wird an Dozierende und Referent:innen als 1. Erinnerungsmail versendet. Enthält TN-Bestätigungs- und Evaluations-QR-Codes.';
    case MailTemplateType.LECTURER_EVALUATION_MAIL:
      return 'Diese Mail wird an Dozierende und Referent:innen als 2. Erinnerungsmail versendet. Enthält TN-Bestätigungs- und Evaluations-QR-Codes.';
    case MailTemplateType.NICHT_ERSCHIENEN:
      return 'Diese Mail wird versendet, wenn ein Teilnehmer den Status "nicht erschienen" erhält.';
    default:
      return '';
  }
}

export function institutionMailVariables(emailType: MailTemplateType): MailTemplateVars[] {
  return globalMailVariables(emailType);
}

export function institutionMailHint(emailType: MailTemplateType): Renderable {
  return globalMailHint(emailType);
}
